module.exports = {
      id: "comment-usage",
      viewBox: "0 0 14 15",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#comment",
      toString: function () {
        return this.url;
      }
    }